module.exports = __webpack_public_path__ + "static/media/materiales-mobile.0012d2a9.jpg";